export var rowValue = {
    display: "grid",
    padding: 0,
    "& > *": {
        display: "table",
    },
};
